$(document).ready(function () {
    // set breakpoint width
    let windowWidth = 1450;

    // start carousel
    $('.carousel').carousel({interval: (window.innerWidth < windowWidth) ? false : 5000});

    // if user rotates phone orientation | window resite
    $(window).on('resize', function (ev) {
        if (window.innerWidth < windowWidth) {
            $('.carousel').carousel({interval: false});
        } else {
            $('.carousel').carousel({interval: 5000});
        }
    })
});

// Счетчики
let a = 0;
$(window).scroll(function () {
    let oTop = $('#counter').offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
        $('.counter-value').each(function () {
            let $this = $(this),
                countTo = $this.attr('data-count');
            $({
                countNum: $this.text()
            }).animate({
                    countNum: countTo
                },
                {
                    duration: 3000,
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.text(this.countNum);
                        //alert('finished');
                    }

                });
        });
        a = 1;
    }

});
